module.exports = __webpack_public_path__ + "assets/img/banner-center3.fec72a76.jpg";